/**
 * Dashboard - Main Dashboard Page
 *
 * The dashboard is the ClinicalDashboard overview (KPI cards, Active CGM
 * Patients list, Recent Clinical Activity). Clicking a patient
 * ("View") navigates to that pet's comprehensive detail page (PetShow →
 * PetGlucoseDetailPanel) rather than expanding in place.
 *
 * Vet-facing only — internal company accounts (admin/cms/it/vetadmin/
 * siteadmin/account_manager) used to see an additional clinic-directory +
 * KPI-count-cards layer here, gated by `isInternalUser`. That surface moved
 * to OPS at /clinic-monitoring (docs/INTERNAL_MONITORING_CONSOLE_PLAN.md
 * Phase 1.5, 2026-06-24). Vetpo is now uniformly the clinic-facing view.
 */

import CompleteClinicProfilePrompt from '../clinic-verification/CompleteClinicProfilePrompt'
import { ErrorBoundary } from '../components/ErrorBoundary'
import OnboardingSharePrompt from '../vet-shares/OnboardingSharePrompt'
import ClinicalDashboard from './ClinicalDashboard'

const Dashboard = () => (
  <ErrorBoundary>
    {/* One-time first-session prompt: invite colleagues, share all pets */}
    <OnboardingSharePrompt />
    {/* Unverified master vets with no clinic block (OAuth signups): collect it and enqueue verification. Mounted AFTER the share prompt so it stacks on top when both fire on a first session. */}
    <CompleteClinicProfilePrompt />
    <ClinicalDashboard />
  </ErrorBoundary>
)

export default Dashboard
